/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_General_Aspect_RatioInputs */

const en_options_general_aspect_ratio = /** @type {(inputs: Options_General_Aspect_RatioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aspect Ratio`)
};

const fr_options_general_aspect_ratio = /** @type {(inputs: Options_General_Aspect_RatioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Format d'image`)
};

const de_options_general_aspect_ratio = /** @type {(inputs: Options_General_Aspect_RatioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seitenverhältnis`)
};

const it_options_general_aspect_ratio = /** @type {(inputs: Options_General_Aspect_RatioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proporzioni`)
};

const ru_options_general_aspect_ratio = /** @type {(inputs: Options_General_Aspect_RatioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Соотношение сторон`)
};

const es_options_general_aspect_ratio = /** @type {(inputs: Options_General_Aspect_RatioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relación de aspecto`)
};

const zh_cn2_options_general_aspect_ratio = /** @type {(inputs: Options_General_Aspect_RatioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`长宽比`)
};

const ja_options_general_aspect_ratio = /** @type {(inputs: Options_General_Aspect_RatioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アスペクト比`)
};

const hi_options_general_aspect_ratio = /** @type {(inputs: Options_General_Aspect_RatioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आस्पेक्ट अनुपात`)
};

const pt_pt2_options_general_aspect_ratio = /** @type {(inputs: Options_General_Aspect_RatioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proporção da tela`)
};

/**
* | output |
* | --- |
* | "Aspect Ratio" |
*
* @param {Options_General_Aspect_RatioInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_general_aspect_ratio = /** @type {((inputs?: Options_General_Aspect_RatioInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_General_Aspect_RatioInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_general_aspect_ratio(inputs)
	if (locale === "de") return de_options_general_aspect_ratio(inputs)
	if (locale === "it") return it_options_general_aspect_ratio(inputs)
	if (locale === "ru") return ru_options_general_aspect_ratio(inputs)
	if (locale === "es") return es_options_general_aspect_ratio(inputs)
	if (locale === "zh-CN") return zh_cn2_options_general_aspect_ratio(inputs)
	if (locale === "ja") return ja_options_general_aspect_ratio(inputs)
	if (locale === "hi") return hi_options_general_aspect_ratio(inputs)
	if (locale === "pt-PT") return pt_pt2_options_general_aspect_ratio(inputs)
	return en_options_general_aspect_ratio(inputs)
});